import { Popover } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { useToggleState } from '../../utils/useToggleState'

export interface NoteIconSettingHintPopoverProps {
  children: React.ReactNode
}

const trigger = ['hover' as const, 'click' as const]
const styles = {
  body: {
    paddingBlock: 6,
    paddingInline: 8,
  },
}

export const NoteIconSettingHintPopover: FunctionComponent<NoteIconSettingHintPopoverProps> =
  memo(props => {
    const [isOpen, , , closePopover] = useToggleState(true)

    return (
      <Popover
        open={isOpen}
        onOpenChange={closePopover}
        placement="left"
        trigger={trigger}
        content="Kliknutím nastavíte ikonu"
        styles={styles}
      >
        {props.children}
      </Popover>
    )
  })
